import { render, staticRenderFns } from "./cognitive-test.vue?vue&type=template&id=04564d6c&"
import script from "./cognitive-test.vue?vue&type=script&lang=ts&"
export * from "./cognitive-test.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports